import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBug, faChartBar, faInfoCircle, faLink, faQuestion, faRedo, faSitemap, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
import { computed } from "vue";
import { useRouter } from "vue-router/composables";
import { copy as sendToClipboard } from "@/utils/clipboard";
import localize from "@/utils/localization";
import { absPath, prependPath } from "@/utils/redirect";
import DatasetDownload from "@/components/History/Content/Dataset/DatasetDownload.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetActions',
    props: {
        item: null,
        writable: { type: Boolean, default: true },
        showHighlight: { type: Boolean, default: false },
        itemUrls: null
    },
    emits: ["toggleHighlights"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faBug, faChartBar, faInfoCircle, faLink, faQuestion, faRedo, faSitemap);
        const router = useRouter();
        const showDownloads = computed(() => {
            return !props.item.purged && ["ok", "failed_metadata", "error"].includes(props.item.state);
        });
        const showError = computed(() => {
            return props.item.state == "error" || props.item.state == "failed_metadata";
        });
        const showInfo = computed(() => {
            return props.item.accessible;
        });
        const showRerun = computed(() => {
            return props.item.accessible && props.item.rerunnable && props.item.creating_job && props.item.state != "upload";
        });
        const showVisualizations = computed(() => {
            // TODO: Check hasViz, if visualizations are activated in the config
            return !props.item.purged && ["ok", "failed_metadata", "error"].includes(props.item.state);
        });
        const reportErrorUrl = computed(() => {
            return prependPath(props.itemUrls.reportError);
        });
        const showDetailsUrl = computed(() => {
            return prependPath(props.itemUrls.showDetails);
        });
        const rerunUrl = computed(() => {
            return prependPath(props.itemUrls.rerun);
        });
        const visualizeUrl = computed(() => {
            return prependPath(props.itemUrls.visualize);
        });
        const downloadUrl = computed(() => {
            return prependPath(`api/datasets/${props.item.id}/display?to_ext=${props.item.extension}`);
        });
        function onCopyLink() {
            const msg = localize("Link copied to your clipboard");
            sendToClipboard(absPath(downloadUrl.value), msg);
        }
        function onDownload(resource) {
            window.location.href = resource;
        }
        function onError() {
            router.push(props.itemUrls.reportError);
        }
        function onInfo() {
            router.push(props.itemUrls.showDetails);
        }
        function onRerun() {
            router.push(`/root?job_id=${props.item.creating_job}`);
        }
        function onVisualize() {
            router.push(props.itemUrls.visualize);
        }
        function onHighlight() {
            emit("toggleHighlights");
        }
        return { __sfc: true, props, emit, router, showDownloads, showError, showInfo, showRerun, showVisualizations, reportErrorUrl, showDetailsUrl, rerunUrl, visualizeUrl, downloadUrl, onCopyLink, onDownload, onError, onInfo, onRerun, onVisualize, onHighlight, faBug, faChartBar, faInfoCircle, faLink, faQuestion, faRedo, faSitemap, FontAwesomeIcon, BButton, DatasetDownload };
    }
});
